import { DataVendor } from 'v2/models';
import defaultCompanyAvatar from 'v2/images/defaultCompanyAvatar.png';

export function getDataVendorAvatarURL(dataVendor: DataVendor): string {
  return dataVendor?.avatar_url || defaultCompanyAvatar;
}
